<script>
import Modal from '../../../components/Modal.vue'
import { debounce } from 'lodash'
import VueSelect from 'vue-select'

export default {
    components: {
        Modal,
        VueSelect,
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        from: {
            type: String,
            default: null
        },
        requisitionId: {
            type: String,
            default: null
        }
    },

    computed: {
        filteredRequisitionJobs() {
            return this.requisitionJobs.filter(job => job.id !== this.jobApplication.job_id)
        }
    },

    data() {
        return {
            requisitionJobs: [],
            recycleJob: null,
            messages: {
                'finish_loading_your_cv': 'We\'ve noticed that there are still some fields that needs information on your CV.  For you to be able to advance to the next step, it is important to complete all fields on your CV.\n\nPlease log onto your profile and complete your CV now.',
                'finish_your_aims_modules': 'We\'ve noticed that your AIMS modules are still outstanding for your '+this.jobApplication.job.title+' application.  For you to be able to advance to the next step, it is important to complete these modules.\n\nPlease log onto your profile and complete them now.',
                'update_your_education': 'We\'ve noticed that your education details are not fully updated for your '+this.jobApplication.job.title+' application.  For you to be able to advance to the next step, it is important to complete this information.\n\nPlease log onto your profile and complete this now.',
                'update_your_killer_questions' : 'We\'ve noticed that you have not completed your Job Questionnaire yet for your '+this.jobApplication.job.title+' application.  For you to be able to advance to the next step, it is important to complete these questions.\n\nPlease log onto your profile and complete this now.',
                'finish_your_language_proficiency_recordings' : 'We\'ve noticed that you have not fully completed your language proficiency recordings yet for your '+this.jobApplication.job.title+' application.  For you to be able to advance to the next step, it is important to upload and complete all your voice recordings.\n\nPlease log onto your profile and complete this now.',
                'finish_your_skills_assessment' : 'We\'ve noticed that you have not completed your skills assessment yet for your '+this.jobApplication.job.title+' application.  For you to be able to advance to the next step, it is important to complete this step.\n\nPlease log onto your profile and complete this now.',
                'give_consent' : 'We\'ve noticed that you have not given consent yet for '+this.jobApplication.job.title+' application.  This consent is for us to be able to run the necessary checks as minimum requirements for this position.  For you to be able to advance to the next step, it is important to give your consent for us to do so.\n\nPlease log onto your profile and complete this now.',
                'upload_your_documents' : 'We\'ve noticed that you have not uploaded all of your required documentation yet for your '+this.jobApplication.job.title+' application.  For you to be able to advance to the next step, it is important to upload these documents.\n\nPlease log onto your profile and upload them now.'
            },
            subjects: {
                'finish_loading_your_cv': 'Finish loading your CV',
                'finish_your_aims_modules': 'Finish your AIMS modules',
                'update_your_education': 'Update your education',
                'update_your_killer_questions': 'Complete your Job Questionnaire',
                'finish_your_language_proficiency_recordings': 'Finish your language proficiency recordings',
                'finish_your_skills_assessment': 'Finish your skills assessment',
                'give_consent': 'Give consent',
                'upload_your_documents': 'Upload your documents'
            },
            selectedMessage: '',
            currentUrl: window.location.href
        }
    },
    watch: {
        selectedMessage(value, oldValue){
            this.currentUrl = window.location.href
        }
    },
    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Send Quick Message">
        <h4>Send a quick message to {{ jobApplication.user.full_name }}</h4>

        <form method="POST"
            action="/recruiter/active-requisitions/send-quick-message">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <input type="hidden" name="user_id" :value="jobApplication.user.id" />
            <input type="hidden" name="redirect_url" :value="currentUrl" />
            <input type="hidden" name="job_application_id" :value="jobApplication.id" />

            <div class="mb-4">
                <label>Message</label>

                <select v-model="selectedMessage">
                    <option value="finish_loading_your_cv">Finish loading your CV</option>
                    <option value="finish_your_aims_modules">Finish your AIMS modules</option>
                    <option value="update_your_education">Update your Education</option>
                    <option value="update_your_killer_questions">Complete your Job Questionnaire</option>
                    <option value="finish_your_language_proficiency_recordings">Finish your Language Proficiency Recordings</option>
                    <option value="finish_your_skills_assessment">Finish your Skills Assessment</option>
                    <option value="give_consent">Give Consent</option>
                    <option value="upload_your_documents">Upload your documents</option>
                </select>

                <br/>
                <br/>
                <textarea class="quick-message" v-if="messages[selectedMessage]" name="message" rows="12">{{ 'Hi ' + jobApplication.user.full_name+'.\n\n' + messages[selectedMessage] + '\n\nThank you.\n\nRegards,\nThe MyCalling Team' }}</textarea>
                <input type="hidden" :value="subjects[selectedMessage]" name="subject">
            </div>

            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink" v-if="messages[selectedMessage]">
                    <button class="button" type="submit">Send</button>
                </div>

                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
  select {
    height: 4rem;
  }

    .quick-message {
        background: white !important;
        border-radius: 5px !important;
        border: 1px solid #D1D1D1 !important;
        margin-bottom: 0 !important;
        height: 100% !important;
        opacity: 1 !important;
    }
</style>
